export type Cookie = {
  key: string;
  title: string;
  description?: string;
  domain?: string;
  vendors: CookieVendor[];
};

export type CookieVendor = {
  name: string;
  description: string;
};

/* Default Cookies */
export const NecessaryCookie = (vendors: CookieVendor[]): Cookie => ({
  key: "hfl_hasAcceptedCookies",
  title: "Nødvendige",
  description:
    "Nødvendige informasjonskapsler hjelper med å gjøre en nettside brukbar ved å aktivere grunnleggende funksjoner, slik som innlogging. Nettsiden kan ikke fungere optimalt uten disse informasjonskapslene.",
  vendors,
});
export const StatisticsCookie = (vendors: CookieVendor[]): Cookie => ({
  key: "analyticsConsent",
  title: "Statistiske",
  description:
    "Statistiske informasjonskapsler hjelper Utdanningsdirektoratet med å forstå hvordan besøkende samhandler med hjemmesiden ved å samle inn og rapportere opplysninger.",
  vendors,
});

/* Default cookie vendors */
export const SentryCookieVendor: CookieVendor = {
  name: "Sentry",
  description:
    "Logger feilmeldinger som vises for brukere for å vite hvor på nettsiden feil oppstår.",
};
export const UidpCookieVendor: CookieVendor = {
  name: "UIDP",
  description:
    "Benyttes for å identifisere brukeren og sikre den gjeldende nettlesersesjonen.",
};
export const ApplicationInsightsCookieVendor: CookieVendor = {
  name: "Application insights",
  description:
    "Samler informasjon om brukerne og deres aktivitet på nettsiden for analyse og rapporteringsformål.",
};
export const MatomoCookieVendor: CookieVendor = {
  name: "Matomo",
  description:
    "Samler informasjon om brukerne og deres aktivitet på nettsiden for analyse og rapporteringsformål.",
};
export const PostHogCookieVendor: CookieVendor = {
  name: "PostHog",
  description:
    "Samler informasjon om brukerne og deres aktivitet på nettsiden for analyse og rapporteringsformål.",
};
